import { selectCurrentLocale } from 'core/locale';
import { useCallback } from 'react';
import { useAppSelector } from 'services/store';
import * as f from 'shared/formatters';
import { FormatOptions } from 'shared/formatters/formatters';

export const useFormatter = () => {
  const currentLocale = useAppSelector(selectCurrentLocale);

  const formatDate = useCallback(
    (date: any, options?: FormatOptions) =>
      f.formatDate(date, currentLocale, options),
    [currentLocale],
  );

  const formatTime = useCallback(
    (date: any, options?: FormatOptions) =>
      f.formatTime(date, currentLocale, options),
    [currentLocale],
  );

  const formatDateTime = useCallback(
    (date: any, options?: FormatOptions) =>
      f.formatDateTime(date, currentLocale, options),
    [currentLocale],
  );

  const formatNumber = useCallback(
    (num: any, options?: Intl.NumberFormatOptions) =>
      f.formatNumber(num, currentLocale, options),
    [currentLocale],
  );

  return { formatDate, formatTime, formatDateTime, formatNumber };
};
